import { Link } from "react-router-dom";

import withLayoutSimple from "../../components/withLayoutSimple/withLayoutSimple";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageCongratulations.module.scss";

function PageCongratulations() {
  const getImgSet = useImgSet();

  const content = getImgSet("content__p38", "png", s.content);

  const back = getImgSet("back__p21", "png");

  return (
    <div className={s.root}>
      <div className={s.inner}>
        {content}
        <Link to="/" className={s.back}>
          {back}
        </Link>
      </div>
    </div>
  );
}

export default withLayoutSimple(PageCongratulations, false, true, true, false);
